import {ReactNode} from "react";
import clsx from "clsx";

type Props = {
    children: ReactNode
    className?:string
}
export const ValidationErrorText = ({children, className} : Props) => {
    return <span className={clsx("text-red-500 text-sm font-bold", className)}>{children}</span>
}